module.exports = __webpack_public_path__ + "static/Roboto-Bold-7c18188784f21915f42a5b3bc9d91e20.ttf";